import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressBook,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faAnglesUp,
  faArrowDown,
  faArrowLeft,
  faArrowRightToBracket,
  faArrowsRotate,
  faArrowsUpDownLeftRight,
  faArrowUpWideShort,
  faAward,
  faBackward,
  faBackwardFast,
  faBan,
  faBars,
  faBook,
  faBookBookmark,
  faBox,
  faBoxArchive,
  faBoxesStacked,
  faBuilding,
  faBuildingColumns,
  faBullhorn,
  faCalendar,
  faCalendarCheck,
  faCalendarDay,
  faCalendarDays,
  faCalendarPlus,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartShopping,
  faCashRegister,
  faChalkboard,
  faChalkboardUser,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleDot,
  faCircleInfo,
  faCircleNotch,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faCloudArrowDown,
  faCloudArrowUp,
  faCloudSun,
  faCog,
  faComment,
  faCommentDollar,
  faComments,
  faCommentsDollar,
  faComputer,
  faCopy,
  faCrown,
  faDownload,
  faEllipsis,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowUp,
  faFileCircleCheck,
  faFileCircleQuestion,
  faFileContract,
  faFileExcel,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFilePen,
  faFileShield,
  faFileSignature,
  faFilter,
  faFilterCircleXmark,
  faFlagCheckered,
  faFloppyDisk,
  faFolderOpen,
  faFolderPlus,
  faForwardStep,
  faGhost,
  faGlobe,
  faGraduationCap,
  faHand,
  faHandHoldingDollar,
  faHandshakeSimple,
  faHeartCrack,
  faHorseHead,
  faHourglassHalf,
  faHouseUser,
  faIdCard,
  faIdCardClip,
  faInfo,
  faInfoCircle,
  faKey,
  faLandMineOn,
  faListCheck,
  faLocationDot,
  faLocationPin,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMessage,
  faMinus,
  faMoneyBillTransfer,
  faMoon,
  faO,
  faPalette,
  faPaperPlane,
  faPencil,
  faPenToSquare,
  faPeopleLine,
  faPeopleRoof,
  faPersonCircleQuestion,
  faPersonDigging,
  faPiggyBank,
  faPlay,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faPrint,
  faQuestionCircle,
  faQuoteRight,
  faReceipt,
  faReply,
  faRightFromBracket,
  faRotateRight,
  faSackDollar,
  faSave,
  faScaleBalanced,
  faScrewdriverWrench,
  faScroll,
  faShare,
  faShieldHalved,
  faSignature,
  faSignHanging,
  faSitemap,
  faSkull,
  faSkullCrossbones,
  faSort,
  faSortDown,
  faSortUp,
  faSquare,
  faSquareCheck,
  faSquarePlus,
  faStamp,
  faStar,
  faStopwatch,
  faSun,
  faTable,
  faTag,
  faTags,
  faThumbsUp,
  faThumbsDown,
  faThumbTack,
  faTicket,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTrashArrowUp,
  faTrashCan,
  faTruck,
  faTruckArrowRight,
  faUnlockKeyhole,
  faUpload,
  faUser,
  faUserClock,
  faUserDoctor,
  faUserGraduate,
  faUserGroup,
  faUserNurse,
  faUserPen,
  faUserPlus,
  faUsers,
  faUserTie,
  faWallet,
  faX,
  faCommentDots,
  faFlask,
  faClipboardList,
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

library.add(
  faFlask,
  faClipboardList,
  faCommentDots,
  faAddressBook,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAnglesLeft,
  faAnglesRight,
  faAnglesUp,
  faArrowDown,
  faArrowLeft,
  faArrowRightToBracket,
  faArrowsRotate,
  faArrowsUpDownLeftRight,
  faArrowUpWideShort,
  faAward,
  faBackward,
  faBackwardFast,
  faBan,
  faBars,
  faBook,
  faBookBookmark,
  faBox,
  faBoxArchive,
  faBoxesStacked,
  faBuilding,
  faBuildingColumns,
  faBullhorn,
  faCalendar,
  faCalendarCheck,
  faCalendarDay,
  faCalendarDays,
  faCalendarPlus,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faCartShopping,
  faCashRegister,
  faChalkboard,
  faChalkboardUser,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleDot,
  faCircleInfo,
  faCircleNotch,
  faClipboard,
  faClock,
  faClockRotateLeft,
  faCloudArrowDown,
  faCloudArrowUp,
  faCloudSun,
  faCog,
  faComment,
  faCommentDollar,
  faComments,
  faCommentsDollar,
  faComputer,
  faCopy,
  faCrown,
  faDownload,
  faEllipsis,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileArrowUp,
  faFileCircleCheck,
  faFileCircleQuestion,
  faFileContract,
  faFileExcel,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFilePen,
  faFileShield,
  faFileSignature,
  faFilter,
  faFilterCircleXmark,
  faFlagCheckered,
  faFloppyDisk,
  faFolderOpen,
  faFolderPlus,
  faForwardStep,
  faGhost,
  faGlobe,
  faGraduationCap,
  faHand,
  faHandHoldingDollar,
  faHandshakeSimple,
  faHeartCrack,
  faHorseHead,
  faHourglassHalf,
  faHouseUser,
  faIdCard,
  faIdCardClip,
  faInfo,
  faInfoCircle,
  faKey,
  faLandMineOn,
  faListCheck,
  faLocationDot,
  faLocationPin,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMessage,
  faMinus,
  faMoneyBillTransfer,
  faMoon,
  faO,
  faPalette,
  faPaperPlane,
  faPencil,
  faPenToSquare,
  faPeopleLine,
  faPeopleRoof,
  faPersonCircleQuestion,
  faPersonDigging,
  faPiggyBank,
  faPlay,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faPrint,
  faQuestionCircle,
  faQuoteRight,
  faReceipt,
  faReply,
  faRightFromBracket,
  faRotateRight,
  faSackDollar,
  faSave,
  faScaleBalanced,
  faScrewdriverWrench,
  faScroll,
  faShare,
  faShieldHalved,
  faSignature,
  faSignHanging,
  faSitemap,
  faSkull,
  faSkullCrossbones,
  faSort,
  faSortDown,
  faSortUp,
  faSquare,
  faSquareCheck,
  faSquarePlus,
  faStamp,
  faStar,
  faStopwatch,
  faSun,
  faTable,
  faTag,
  faTags,
  faThumbsUp,
  faThumbsDown,
  faThumbTack,
  faTicket,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTrashArrowUp,
  faTrashCan,
  faTruck,
  faTruckArrowRight,
  faUnlockKeyhole,
  faUpload,
  faUser,
  faUserClock,
  faUserDoctor,
  faUserGraduate,
  faUserGroup,
  faUserNurse,
  faUserPen,
  faUserPlus,
  faUsers,
  faUserTie,
  faWallet,
  faWhatsapp,
  faX,
);
